<template>
  <div id="home">
    <!-- 700 * 1094px -->
    <v-alert
      class="alert-wishlist"
      height="50"
      transition="fade-transition"
      v-model="alertaWishlist"
      color="#A37E60"
    >
      <span>Se ha agregado a tu colección personal</span>
      <div class="centrar-right">
        <router-link to="/wishlist" class="white--text">
          <span class="d-inline-block mr-3">VER MI COLECCIÓN PERSONAL</span>
          <v-icon color="white">mdi-heart-outline</v-icon>
        </router-link>
      </div>
    </v-alert>

    <v-alert
      class="alert-NoSesion"
      height="50"
      transition="fade-transition"
      v-model="alertaNoSesion"
      color="#A37E60"
    >
      <span>Inicia sesión para agregar productos a tu Colección Personal</span>
      <div class="centrar-right">
        <router-link to="/login" class="verde-oscuro">
          <span>INICIA SESIÓN</span>
          <v-icon class="d-inline-block ml-3">mdi-account-outline</v-icon>
        </router-link>
      </div>
    </v-alert>

    
    <!-- ***********************Intro full**************** -->
    <v-container fluid class="py-0">
      <v-row>
        <v-col class="pt-0 px-0">
          <div
            class="home-carousel-div-relative"
            style="height: 100vh"
            v-bind:class="{'carousel-1':carousel_principal%3 == 0,'carousel-2':carousel_principal%3 == 1,'carousel-3':carousel_principal%3 == 2}"
          >

            <img src="@/assets/img/fotos/sillon-2.jpg" class="d-none" />
            <img src="@/assets/img/fotos/sala-2.jpg" class="d-none" />
            <img src="@/assets/img/fotos/cocina-2.jpg" class="d-none" />
            <!-- <v-carousel
              :show-arrows="false"
              :hide-delimiter-background="true"
              height="100vh"
              :hide-delimiters="true"
              :interval="4000"
              cycle
            >
              <v-carousel-item  transition="fade-transition">
                <v-img height="100vh" src="@/assets/img/fotos/intro-chlorophilia-1.jpg"></v-img>
              </v-carousel-item>

              <v-carousel-item  transition="fade-transition">
                <v-img height="100vh" src="@/assets/img/fotos/intro-chlorophilia-2.jpg"></v-img>
              </v-carousel-item>

              <v-carousel-item  transition="fade-transition">
                <v-img height="100vh" src="@/assets/img/fotos/intro-chlorophilia-3.jpg"></v-img>
              </v-carousel-item>
            </v-carousel>-->

            <div class="home-intro-texts text-center">
              <v-img src="@/assets/img/logos/logo-blanco.svg" class="d-none d-sm-flex" width="350px"></v-img>
              <v-img src="@/assets/img/logos/logo-blanco.svg" class="d-sm-none" width="250px"></v-img>
            </div>

            <div class="home-intro-arrow text-center" @click="$vuetify.goTo(segundoBloque)">
              <v-img src="@/assets/img/iconos/flecha-abajo.svg"></v-img>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- ***********************/Intro full**************** -->




    <!-- ************** SECCIÓN REGALOS ************ -->
    <div class="bloque-fondo-gris-regalos d-none d-md-block" style="position: relative;">
      
      <div class="flecha-regalo-prev">
        <v-btn :disabled="carousel_regalos == 0" fab small depressed color="white" :ripple="false"
        >
          <v-icon @click="carousel_regalos--" style="font-size: 30px; color: #CA8B37">mdi-chevron-left</v-icon>
        </v-btn>
      </div>
      <div class="flecha-regalo-next">
        <v-btn fab small depressed color="white" :ripple="false">
          <v-icon @click="carousel_regalos++" style="font-size: 30px; color:#CA8B37" :disabled="carousel_regalos == regalos.length - 1">mdi-chevron-right</v-icon>
        </v-btn>
      </div>
      <v-container class="d-none d-md-block">
        <v-row class="my-12">
          <v-col cols="6" class="text-right">
            <template v-for="(regalo,i) in regalos">
              <v-img :src="'https://strapi.actstudio.xyz/'+regalo.Imagen[0].url" :key="i" class="animated fadeIn ml-auto d-block" v-if="carousel_regalos == i" width="450px" height="450px" :contain="true"></v-img>
            </template>
          </v-col>
          <v-col cols="5" offset="1">
            <span class="encabezado verde-oscuro d-block mb-12" style="max-width: 500px;width: 100%; letter-spacing: 1px; font-size: 35px;">
              ¿Chlorophilia de regalo?
            </span>
            <template v-for="(regalo,i) in regalos" >
              <template v-if="carousel_regalos == i">
              
                <template v-if="regalo.tipo == 'Maceta'">
                  <div :key="i">
                    <span class="titulo d-block animated fadeIn">{{regalo.NombreComun}}</span>
                    <span class="subtitulo animated fadeIn d-block mb-5" style="font-size: 12px; color: #979797; text-transform: uppercase; margin:0px 0px"
                    >{{regalo.NombreCientifico}}</span>

                    <v-img :src="'https://strapi.actstudio.xyz'+regalo.DisenoMaceta.url" width="50px"></v-img>
                    <div class="mt-2 mb-5">
                      <span>
                        <b class="modernist-bold uppercase">Maceta: </b>
                        {{regalo.Nombre}}
                      </span>
                    </div>

                    <div>
                      <span class="encabezado">${{regalo.Precio}}</span>
                    </div>
                    <v-btn color="#064434" tile elevation="0" class="mt-3" dark @click="comprarAhora(regalo);" :ripple="false" width="200px">
                      <span class="modernist-bold" style="font-size: 12px">
                        ¡Comprar Ahora!
                      </span>
                    </v-btn>
                    <div>
                      <small>* Aplican condiciones de entrega inmediata</small>
                    </div>
                  </div>
                </template>
                <template v-if="regalo.tipo == 'Base'">
                  <div :key="i">
                    <span class="titulo d-block animated fadeIn">{{regalo.NombreComun}}</span>
                    <span class="subtitulo animated fadeIn d-block mb-5" style="font-size: 12px; color: #979797; text-transform: uppercase; margin:0px 0px"
                    >{{regalo.NombreCientifico}}</span>

                    <v-img :src="'https://strapi.actstudio.xyz'+regalo.DisenoMaceta.url" width="50px"></v-img>
                    <!-- <v-img :src="'https://strapi.actstudio.xyz'+regalo.Imagen[0].url"></v-img> -->
                    <div class="mt-2 mb-5">
                      <span>
                        <div>
                          <b class="modernist-bold uppercase">Maceta: </b>
                          {{regalo.MacetaNombre}}
                        </div>

                        <div>
                          <b class="modernist-bold uppercase">Base:</b>
                          {{regalo.Nombre}}
                        </div>
                      </span>
                    </div>
                    <div>
                      <span class="encabezado">${{regalo.Precio}}</span>
                    </div>
                    <v-btn color="#064434" tile elevation="0" class="mt-3" dark @click="comprarAhora(regalo);" :ripple="false" width="200px">
                      <span class="modernist-bold" style="font-size: 12px">
                        ¡Comprar Ahora!
                      </span>
                    </v-btn>
                    <div>
                      <small>* Aplican condiciones de entrega inmediata</small>
                    </div>
                  </div>
                </template>
              </template>
            </template>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="bloque-fondo-gris-regalos d-md-none" style="position: relative;">
      <div class="flecha-regalo-prev">
        <v-btn :disabled="carousel_regalos == 0" fab small depressed color="white" :ripple="false"
        >
          <v-icon @click="carousel_regalos--" style="font-size: 30px; color: #CA8B37">mdi-chevron-left</v-icon>
        </v-btn>
      </div>
      <div class="flecha-regalo-next">
        <v-btn fab small depressed color="white" :ripple="false">
          <v-icon @click="carousel_regalos++" style="font-size: 30px; color:#CA8B37" :disabled="carousel_regalos == regalos.length - 1">mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    
      <v-container fluid class="d-md-none">
        <v-row>
          <v-col cols="12" class="text-center">
            <span class="encabezado pb-50 mx-auto hidden-md-and-up" style="letter-spacing: 1px; font-size: 35px;">¿Chlorophilia de regalo?</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-carousel height="460px" :hide-delimiters="true" v-model="carousel_regalos" cycle :show-arrows="false">
              <v-carousel-item v-for="(regalo,i) in regalos" :key="i">
                <template v-if="regalo.tipo == 'Maceta'">
                  <div class="text-center">
                    <img :src="'https://strapi.actstudio.xyz/'+regalo.Imagen[0].url" alt style="max-width: 200px" class="d-block mx-auto"/>
                    <span class="titulo d-block animated fadeIn">{{regalo.NombreComun}}</span>
                    <span class="subtitulo animated fadeIn d-block" style="font-size: 12px; color: #979797; text-transform: uppercase; margin:0px 0px"
                    >{{regalo.NombreCientifico}}</span>
                    <div>
                      <span>
                        <b>Maceta: </b>
                        {{regalo.Nombre}}
                      </span>
                    </div>
                    <div>
                      <span class="encabezado">${{regalo.Precio}}</span>
                    </div>
                    <v-btn color="#064434" tile elevation="0" class="mt-3" :ripple="false" width="200px" @click="comprarAhora(regalo);">
                      <span class="modernist-bold" style="font-size: 12px;">
                        ¡Comprar Ahora!
                      </span>
                    </v-btn>
                    <div>
                      <small>* Aplican condiciones de entrega inmediata</small>
                    </div>
                  </div>
                </template>
                <template v-if="regalo.tipo == 'Base'">
                  <div class="text-center">
                    <img :src="'https://strapi.actstudio.xyz/'+regalo.Imagen[0].url" alt style="max-width: 200px" class="d-block mx-auto"/>
                    <span class="titulo d-block animated fadeIn">{{regalo.NombreComun}}</span>
                    <span class="subtitulo animated fadeIn d-block" style="font-size: 12px; color: #979797; text-transform: uppercase; margin:0px 0px"
                    >{{regalo.NombreCientifico}}</span>
                    <div>
                      <span>
                        <b>Maceta: </b>
                        {{regalo.MacetaNombre}}
                        <b>Base:</b>
                        {{regalo.Nombre}}
                      </span>
                    </div>
                    <div>
                      <span class="encabezado">${{regalo.Precio}}</span>
                    </div>
                    <v-btn color="#064434" tile elevation="0" class="mt-3" :ripple="false" width="200px" @click="comprarAhora(regalo);">
                      <span class="modernist-bold" style="font-size: 12px;">
                        ¡Comprar Ahora!
                      </span>
                    </v-btn>

                    <div>
                      <small>* Aplican condiciones de entrega inmediata</small>
                    </div>
                  </div>
                </template>
              </v-carousel-item>
            </v-carousel>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- ************** FIN SECCIÓN REGALOS ************ -->


    <!-- ************** SECCIÓN EXPLORA NUESTRO CATÁLOGO (BANNER) ************ -->
    <v-container fluid py-0 ma-0>
      <v-row style="height: 400px;" align="center" class="banner-explora">
        <v-col cols="12" class="text-center">
          <router-link to="/tienda" class="descubre-coleccion-completa d-inline-block mx-auto py-8 px-8" style="background-color: #064434;">

            <img src="@/assets/img/gif/1-EXPLORA.gif" alt class="d-block mx-auto pb-4" style="max-width: 120px;" />
          
            <span class="boton-explora-catalogo">DESCUBRE LA COLECCIÓN COMPLETA <span class="dorado d-block my-3">SPRING SUMMER 2020</span></span>
          </router-link>
        </v-col>
      </v-row>

        <!-- <img
          class="img-home-banner-explora"
          src="../assets/img/identidad/chlorophilia-identidad-13.jpg"
          alt
        /> -->
        
        <!-- <img src="@/assets/img/gif/1-EXPLORA.gif" class="home-explora-gif" alt /> -->

    </v-container>
    <!-- ************** FIN SECCIÓN EXPLORA NUESTRO CATÁLOGO (BANNER) ************ -->

    
    


    <!-- ************** SECCIÓN LIFESTYLES ************ -->
    <div id="segundoBloque">
      <span  class="separador encabezado padding-personalizado d-none d-sm-block text-center mx-auto" style="padding: 80px 0px 20px 0px; max-width: 658px">Selecciona una planta de la colección que hemos curado para ti, su tamaño y entre macetas de hermosos colores y texturas; con o sin bases en metal o madera</span>
      
      <span class="separador encabezado padding-personalizado d-block d-sm-none text-center mx-auto" style="padding: 80px 0px 20px 0px; max-width: 900px">Selecciona una planta de la colección que hemos curado para ti</span>
    </div>
    

    <v-container home-encuentra-estilo fluid px-0 px-md-3>
      <v-carousel
        height="auto"
        :hide-delimiter-background="true"
        :hide-delimiters="true"
        :show-arrows="false"
        v-model="estilo_activo"
        :cycle="true"
        
      >
        <v-carousel-item v-for="(lifestyle,i) in lifestyles" :key="i">
          <v-row style="position:relative;" justify="center">
            <v-col cols="12" md="7" lg="6">
              <v-row  justify-md="end" align-md="center" align-lg="start" class="imagen-lifestyle-container">
                <v-col cols="12" md="12" class="pt-0">
                  <div>
                    <div class="home-item-preview fadeIn animated  text-lg-right">
                      <!-- <img :src="'https://strapi.actstudio.xyz/'+lifestyle.Imagenes[0].url" /> -->
                      <div>
                        <img :src="'https://strapi.actstudio.xyz'+lifestyle.Imagenes[0].url" alt />
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <!-- catalogo desktop -->
            <v-col md="5" lg="6" xl="5" offset-xl="1" class="d-none d-md-block transform-lg">
              <v-row justify="start">
                <v-col
                  cols="12"
                  md="10"
                  lg="8"
                  class="pt-0"
                  v-for="(producto,i) in lifestyle.productos"
                  :key="i"
                >
                  <div class="d-flex">
                    <div class="home-item-col" @click="cambiar_producto_seleccionado(i)">
                      <!--  <img src="../assets/img/fotos/dark-green-plants-decor-flowerpot-1974508.jpg" alt=""> -->
                      <img :src="'https://strapi.actstudio.xyz/'+producto.Galeria[0].url" alt />
                      <!-- <router-link
                        :to="'/tienda/'+producto.url"
                        class="home-boton-item"
                      >VER PRODUCTO</router-link> -->
                    </div>
                    <div class="home-item-col-datos">
                      <span class="titulo d-inline-block">{{producto.NombreComun}}</span>
                      <span class="subtitulo">{{producto.NombreCientifico}}</span>
                      
                      <div id="btns-ver-wish" class="mt-md-4 mt-lg-5 d-flex" style="vertical-align: bottom;">
                        <v-btn :href="'/tienda/'+producto.url" tile color="#064434" elevation="0" height="30">
                          <span class="modernist-bold d-block mx-auto text-center btn-ver-producto-slider">
                            VER PRODUCTO
                          </span>
                        </v-btn>
                        <span @click="agregarWishlist(producto.id);" class="boton-favorito d-inline-block ml-3">
                          <img src="../assets/img/iconos/wishlist_n.svg" alt />
                        </span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <!-- slider catalogo mobile -->
            <v-col cols="12" class="pt-0 d-md-none slider-mobile">
              <v-row>
                <v-col cols="3" v-for="(producto, i) in lifestyle.productos" :key="'productos-lifestyle'+i">
                  <v-img :src="'https://strapi.actstudio.xyz'+producto.ImagenPrincipal.url" @click="prod_activo_lifestyle = i" class="lifestyle-productos-mobile" v-bind:class="{'opacity-3': prod_activo_lifestyle != i}"></v-img>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col cols="12" class="text-center">
                  <template v-for="(prod, i) in lifestyle.productos">
                    <div :key="'prod-lifestyles-'+i" v-if="prod_activo_lifestyle == i">

                      <span class="titulo d-block">{{prod.NombreComun}}</span>
                      <span class="subtitulo d-block pb-5">{{ prod.NombreCientifico }}</span>

                      <router-link
                        :to="'/tienda/'+prod.url"
                        class="boton-ver-producto d-inline-block mr-3"
                      >VER PRODUCTO</router-link>
                    </div>
                  </template>
                </v-col>
              </v-row>
              <!-- <v-row justify="center">
                <v-col cols="12" sm="6">
                  <v-slide-group v-model="slider_productos" mandatory>
                    <v-slide-item
                      v-slot:default="{ active, toggle }"
                      v-for="(producto,i) in prods"
                      :key="i"
                      v-on:click="producto_activo = i; cambiar_slide()"
                    >
                      <div
                        class="home-item-col"
                        @click="toggle(); cambiar_slide(i);  mostrarProducto(producto);"
                        v-bind:class="{ activo: active }"
                      >
                        
                        <img :src="'https://strapi.actstudio.xyz/'+producto.Galeria[0].url" alt />
                      </div>
                    </v-slide-item>
                  </v-slide-group>
                </v-col>
              </v-row> -->

              <v-row justify="center">
                <v-col cols="11" class="text-center">
                  <template v-for="(prod,i) in prods">
                    <div id="productoName" :key="i">
                      <template v-if="slider_productos == i ">
                        <span class="titulo d-block">{{prod.NombreComun}}</span>
                        <span class="subtitulo d-block pb-5">{{ prod.NombreCientifico }}</span>

                        <router-link
                          :to="'/tienda/'+prod.url"
                          class="boton-ver-producto d-inline-block mr-3"
                        >VER PRODUCTO</router-link>
                      </template>
                    </div>
                  </template>
                </v-col>
              </v-row>
            </v-col>
            <!-- /slider catalogo mobile -->

            <v-carousel
              class="home-carousel-productos-mobile"
              height="auto"
              :hide-delimiter-background="true"
              :show-arrows="false"
              delimiter-icon="mdi-minus"
              ref="indicadorcarousel"
            >
              <v-carousel-item
                class="home-bloque-info-mobile text-center hidden-md-and-up"
                v-for="(producto,i) in productos"
                :key="i"
              >
                <div>
                  <router-link to class="home-boton-item-mobile">VER PRODUCTO</router-link>
                  <span class="titulo d-block">{{ producto.nombreComun }}</span>
                  <span class="subtitulo d-block">{{ producto.nombreCientifico }}</span>

                  <span
                    class="titulo d-block"
                    v-if="producto.ActivoChico"
                  >${{ producto.precioChico }}</span>
                  <span v-else-if="producto.ActivoMediano">{{ producto.precioMediano }}</span>
                  <span v-else>{{ producto.precioGrande }}</span>
                </div>
              </v-carousel-item>
            </v-carousel>
            <!-- flechas -->
            <div class="home-estilo-unico-flechas hidden-sm-and-down">
              <v-btn
                class="flecha-prev hidden-md-and-down"
                v-if="estilo_activo > 0"
                fab
                small
                depressed
                color="white"
                :ripple="false"
              >
                <v-icon
                  @click="estilo_activo--"
                  style="font-size: 30px; color: #CA8B37"
                >mdi-chevron-left</v-icon>
              </v-btn>

              <v-btn class="flecha-sig" fab small depressed color="white" :ripple="false">
                <v-icon
                  @click="estilo_activo++"
                  style="font-size: 30px; color:#CA8B37"
                >mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </v-container>
    <!-- ************** FIN SECCIÓN LIFESTYLES ************ -->

    





    <!-- ************** SECCIÓN EL PHILIA EN CHLOROPHILIA ************ -->
    <v-container home-segundo-bloque class="padding-bottom-segundo-bloque">
      <v-row>
        <v-col
          cols="12"
          lg="6"
          class="home-bloque-blanco background-green padding-columns text-left"
        >
          <v-row align="center" style="height: 100%;">
            <v-col cols="12" md="4" class="align-self-md-center d-block d-md-none d-lg-block">
              <router-link to="/philia">
                <v-img
                  src="@/assets/img/iconos/ph-icon.svg"
                  class="d-block d-sm-none d-lg-block mx-auto home-segundo-bloque-ph-icon"
                ></v-img>
              </router-link>
            </v-col>

            <v-col cols="12" sm="12" lg="8" class="align-self-center align-self-md-center">
              <div class="pr-0 pr-sm-0 pr-lg-10">
                <router-link to="/philia">
                  <v-img
                    src="@/assets/img/iconos/ph-icon.svg"
                    class="d-none d-sm-block d-lg-none mx-auto home-segundo-bloque-ph-icon"
                    style="margin-bottom:20px;"
                  ></v-img>
                </router-link>
                <router-link to="/philia">
                  <span
                    class="titulo d-block blanco text-center text-sm-center text-lg-left"
                  >PHILIA</span>
                </router-link>
                <!--****************** div oculto en pantallas chicas************** -->

                <div class="hidden-md-and-down">
                  <span
                    class="texto-corrido blanco d-block texto-philia" style="font-size: 12px;"
                  >Con el término griego “chloros” que significa verde; “phylla” para hojas y “philia” que refiere amor, cuidado y afecto, se explican nuestro nombre y compromiso por llevarte a casa la mejor selección de plantas, sustrato y macetas, bajo el más riguroso cuidado.</span>
                  <router-link to="/philia" class="d-block mt-3" style="color:white;">LEER MÁS</router-link>
                </div>
                <!--****************** /div oculto en pantallas chicas************** -->
              </div>
            </v-col>

            <!--****************** columna oculta en pantallas grandes************** -->
            <v-col cols="12" class="hidden-lg-and-up paddings-mobile-bloques">
              <div class="px-3 pb-3">
                <span
                  class="texto-corrido blanco texto-philia d-block mx-auto text-center" style="font-size: 12px;"
                >Con el término griego “chloros” que significa verde; “phylla” para hojas y “philia” que refiere amor, cuidado y afecto, se explican nuestro nombre y compromiso por llevarte a casa la mejor selección de plantas, sustrato y macetas, bajo el más riguroso cuidado.</span>
                <router-link to="/philia" class="d-block mt-3 text-center" style="color:white;">LEER MÁS</router-link>
              </div>
            </v-col>
            <!-- **************/columna oculta en pantallas grandes*************** -->
          </v-row>
        </v-col>

        <v-col
          cols="12"
          lg="6"
          class="text-left text-md-center px-6 py-6 py-md-12 padding-columns"
          style="background: #E2D4CA;"
        >
          <div style="color: #03241D;">
            <router-link to="/philia" class="verde-oscuro">
              <span class="titulo d-block mt-5 mt-md-7 mb-6 text-center">ABOUT</span>
            </router-link>
            <span
              class="texto-corrido d-block mb-8 paddings-mobile-bloques2 mx-auto texto-about"
            >Somos un grupo de apasionados por las plantas y el diseño; de “potted jungle geeks” que apreciamos lo inspiradores que resultan esos “rinconcitos verdes” en los que leemos, trabajamos o nos bebemos un café; que sabemos que te encanta sembrar y cuidar tus plantas pero que aprecias la facilidad de elegir entre hermosas macetas y una cuidadosa selección de especies. También sabemos, como tú, que no hay mejor regalo que un planta y sobre todo, que un mundo más verde siempre resultará más inspirador.</span>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- ************** FIN SECCIÓN EL PHILIA EN CHLOROPHILIA ************ -->




    <!-- ************** SECCIÓN DESTACADOS ************ -->
    <v-container intro-container pb-25>
      <span
      class="separador encabezado padding-personalizado d-block text-center mx-auto"
      style="padding: 0px 0px 50px 0px; max-width: 900px">Especies favs <br class="d-sm-none"> de la semana</span>
      <div class="home-bloque-destacados">
        
        <div class="flecha-izq">
        
          <v-btn
                class="flecha-prev"
                :disabled="imagen_intro == 0"
                fab
                small
                depressed
                color="white"
                :ripple="false"
              >
            <v-icon
              @click="imagen_intro--"
              style="font-size: 30px; color: #CA8B37"
            >mdi-chevron-left</v-icon>
          </v-btn>
        </div>

        <div class="flecha-der">
          <v-btn class="flecha-sig" fab small depressed color="white" :ripple="false" :disabled="imagen_intro == prods.length - 1 ">
            <v-icon
              @click="imagen_intro++"
              style="font-size: 30px; color:#CA8B37"
            >mdi-chevron-right</v-icon>
          </v-btn>
        </div>

        <v-row no-gutters>
          

          <v-col cols="12" md="6" lg="6" class="pa-0 mb-0 mb-sm-5">
            <v-row justify="center" justify-md="end">
              <v-col cols="12">
                <transition
                  name="custom-classes-transition"
                  enter-active-class="animated fadeIn"
                  mode="out-in"
                >
                  <template v-for="(producto,i) in prods">
                    <div :key="i" v-if="imagen_intro == i">
                      <div class="home-bloque-destacados-img" v-if="imagen_intro == i">
                        <div>
                          <img :src="'https://strapi.actstudio.xyz/'+producto.ImagenPrincipal.url" alt />
                        </div>
                      </div>
                    </div>
                  </template>
                </transition>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="6" lg="6" class="home-bloque-destacados-col-info align-self-center">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated fadeIn"
              mode="out-in"
            >
              <template v-for="(producto,i) in prods">
                <div :key="i" v-if="imagen_intro == i">
                  <div class="home-item-info margin-top-info">
                    <span class="titulo d-block">{{producto.NombreComun}}</span>
                    <span class="subtitulo d-block pb-5">{{ producto.NombreCientifico }}</span>
                    <span class="texto-corrido2">{{producto.Descripcion}}</span>

                    <div class="home-item-botones">
                      <router-link
                        :to="'/tienda/'+producto.url"
                        class="boton-ver-producto d-inline-block mr-3"
                      >VER PRODUCTO</router-link>
                      <span class="boton-favorito d-inline-block" @click="agregarWishlist(producto.id)" style="cursor: pointer;">
                        <img src="../assets/img/iconos/wishlist_n.svg" alt />
                      </span>
                    </div>
                    <!-- <div class="home-bloque-destacados-controles d-block d-sm-block">
                      <div>
                        <v-btn
                          text
                          icon
                          color="#A37E60"
                          x-large
                          @click="cambiar_slide_destacada(i)"
                          v-for="(producto,i) in prods"
                          :key="i"
                          class="btns"
                        >
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                      </div>
                    </div> -->
                  </div>
                </div>
              </template>
            </transition>
            <div class="home-hojas-div d-none d-md-block">
              <v-row>
                <v-col cols="12" md="6" lg="6" class="pa-0"></v-col>
                <v-col cols="12" md="6" lg="6" class="pa-0">
                  <marquee
                    class="titulo home-marquee-tienda hidden-xs-only"
                    behavior="scroll"
                    direction="left"
                    v-if="false"
                  >
                    ¡Hola! Puedes elegir especie, tamaño, maceta y base
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ¡Hola! Puedes elegir especie, tamaño, maceta y base
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ¡Hola! Puedes elegir especie, tamaño, maceta y base
                  </marquee>
                  <!-- adornos -->
                  <img
                    src="../assets/img/hojas-slider-01.svg"
                    alt
                    class="home-bloque-destacados-hoja1"
                  />
                  <img
                    src="../assets/img/hojas-slider-02.svg"
                    alt
                    class="home-bloque-destacados-hoja2"
                  />

                  <!-- controles -->
                  <div class="home-bloque-destacados-controles d-block d-sm-none">
                    <v-btn
                      text
                      icon
                      color="#A37E60"
                      x-large
                      @click="cambiar_slide_destacada(i)"
                      v-for="(producto,i) in prods"
                      :key="i"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <!-- ************** FIN SECCIÓN DESTACADOS ************ -->



    

    

    

    <!-- regalar planta -->

    <!-- <v-container home-acerca-de pt-50 px-0 fluid fill-height>
      <v-row align="center" justify="center" no-gutters>
        <v-col cols="12" lg="6">
          <div class="home-col-texto">
            <span class="titulo d-block">ACERCA DE NOSOTROS</span>
            <span class="texto-corrido">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Totam error similique sapiente
              possimus
              veritatis, ipsa laudantium quod temporibus sequi, non rem ad natus. Ipsum, voluptas quo. Ea
              repudiandae
              porro iure. Minima accusamus sapiente quas at voluptatibus unde culpa quasi porro! Ipsam tempora
              veniam
              ipsa dolorem facere eveniet non, impedit saepe.
            </span>
          </div>
        </v-col>
        <v-col cols="12" lg="6">
          <img src="../assets/img/fotos/dark-green-plants-decor-flowerpot-1974508.jpg" alt />
        </v-col>
      </v-row>
    </v-container>-->

    <span
      class="separador encabezado padding-explora-personalizado d-block text-center"
    >Explora los artículos de nuestro blog</span>

    <v-container home-explora-articulos>
      <v-row>
        <v-col
          cols="12"

          md="6"
          class="pa-lg-0 py-0 px-3"
          v-for="(post,p) in posts"
          :key="p"
          style="margin-bottom: 90px"
        >
          <router-link :to="'/Blog/'+post.Url" style="color: #02261D;">
            <div class="home-articulo-container">
              <img :src="'https://strapi.actstudio.xyz'+post.Cover.url" alt />
              <div class="home-articulo-hover">
                <div class="home-articulo-bloque-titulo bg-rosa">
                  <div>
                    <span class="subtitulo d-block">TIPS</span>
                    <span class="titulo">{{post.Titulo}}</span>
                  </div>
                </div>
              </div>
              <div class="home-articulo-img-identidad">
                <div class="home-articulo-bloque-titulo">
                  <div>
                    <span class="subtitulo d-block">TIPS</span>
                    <span class="titulo">{{post.Titulo}}</span>
                  </div>
                </div>
                <img
                  class="hidden-xs-only"
                  src="../assets/img/identidad/chlorophilia-identidad-12.jpg"
                  alt
                />
              </div>
            </div>
          </router-link>
        </v-col>
      </v-row>
    </v-container>

    

    <v-container fluid fill-height home-agendar-cita py-0 v-if="false">
      <v-row no-gutters>
        <v-col order-lg="1" order="12" cols="12" lg="6" class="pa-0">
          <div class="home-agendar-cita-foto">
            <img src="../assets/img/fotos/dark-green-plants-decor-flowerpot-1974508.jpg" alt />
          </div>
        </v-col>
        <v-col order-lg="12" order="1" cols="12" lg="6">
          <v-row class="fill-height" align="center" no-gutters>
            <div class="home-div-agendar-cita">
              <div>
                <img src="../assets/img/plantas-diseño-01.svg" alt />
                <img src="../assets/img/plantas-diseño-02.svg" alt />
                <img src="../assets/img/plantas-diseño-03.svg" alt />
              </div>
              <span class="titulo d-block">Diseñamos tu proyecto</span>
              <span class="texto-corrido d-block">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat adipisci doloribus ratione
                vel cumque
                consequuntur ipsam deleniti repellendus harum repellat! Architecto, aliquid iure expedita
                quaerat
                tempora enim asperiores id illo.
              </span>
              <a href class="boton-agendar-cita">AGENDA UNA CITA</a>
            </div>
          </v-row>
        </v-col>
      </v-row>

      
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import VueSession from "vue-session";
import axios from "axios";
import marked from "marked";
Vue.use(VueSession, { persist: true });
// import TerminosYCondiciones from "@/components/TerminosYCondiciones.vue";

export default {
  components: {},
  data: function() {
    return {
      prod_activo_lifestyle: 0,
      carousel: 0,
      carousel_regalos: 0,
      carousel_principal: 0,
      slider_productos: null,
      productos: [],
      /* bloque intro */
      imagen_intro: 0,
      /* bloque catalogo */
      producto_activo: 0,
      /* bloque regalo */
      regalo_activo: 0,
      /* bloque estilo único */
      estilo_activo: 0,
      tamano: 1,
      prods: [],
      posts: [],
      lifestyles: [],
      dialog: false,
      segundoBloque: "#segundoBloque",
      imagen_slider: 0,
      //popup promociones
      popups: [],
      promociones: false,
      regalos: [],
      macetas:[],
      bases: [],
      alertaWishlist: false,
      alertaNoSesion: false,
      wishlist: [],
      destacado_activo: 0
    };
  },
  created() {
    axios
      .get(
        "https://strapi.actstudio.xyz/posts?Activo=true&_limit=2&_sort=created_at:DESC"
      )
      .then(response => {
        this.posts = response.data;
      });

    axios
      .get("https://strapi.actstudio.xyz/pop-ups?Activo=true")
      .then(response => {
        this.popups = response.data;
      });

    axios
      .get("https://strapi.actstudio.xyz/nombre-comuns?Activo=true&DestacadoHome=true", {
      })
      .then(response => {
        this.prods = response.data;
      });

    axios.get("https://strapi.actstudio.xyz/lifestyles").then(response => {
      this.lifestyles = response.data;
    });

    axios.get("https://strapi.actstudio.xyz/nombre-comuns/getRegalos").then(response => {
      this.regalos = response.data;


      var macetas = [];
      var bases = [];

      for (let r_index = 0; r_index < this.regalos.length; r_index++) {
        for (let m_index = 0; m_index < this.regalos[r_index].Maceta.length; m_index++) {


          if(this.regalos[r_index].Maceta[m_index].ActivarRegalo){
            var mc = this.regalos[r_index].Maceta[m_index];
            mc.NombreComun = this.regalos[r_index].NombreComun;
            mc.NombreCientifico = this.regalos[r_index].NombreCientifico;
            mc.DisenoMaceta = this.regalos[r_index].Maceta[m_index].DisenoMaceta;
            mc.Tipo = 'Maceta';
            macetas.push(mc);
          }


          
          for (let b_index = 0; b_index < this.regalos[r_index].Maceta[m_index].Base.length; b_index++) {
            if(this.regalos[r_index].Maceta[m_index].Base[b_index].ActivarComoRegalo){
              var bs = this.regalos[r_index].Maceta[m_index].Base[b_index];
              bs.NombreComun = this.regalos[r_index].NombreComun;
              bs.NombreCientifico = this.regalos[r_index].NombreCientifico;
              bs.MacetaNombre = this.regalos[r_index].Maceta[m_index].Nombre;
              bs.DisenoMaceta = this.regalos[r_index].Maceta[m_index].DisenoMaceta;
              bs.Tipo = 'Base';
              bases.push(bs);   
            }
          }
        }
      }

      this.regalos = [];
      for (let m = 0; m < macetas.length; m++) {
        macetas[m].tipo = 'Maceta';
        this.regalos.push(macetas[m]);
      }

      for (let n = 0; n < bases.length; n++) {
        bases[n].tipo = 'Base';
        this.regalos.push(bases[n]);
      }

      this.macetas = macetas;
      this.bases = bases;

      if (this.$session.exists("user")) {
        if (this.$session.get("user") != undefined) {
          axios
            .get(
              "https://strapi.actstudio.xyz/users/" +
                this.$session.get("user").user.id,
              {
                headers: {
                  Authorization: `Bearer ${this.$session.get("user").jwt}`
                }
              }
            )
            .then(response => {
              this.wishlist = response.data.productos;
            })
            .catch(error => {});
        }
      }
    });

    // axios.post('https://www.cpcms.actstudio.xyz/api/collections/get/Productos?token=c88bdc0ebcb7f81a8c480681c41652', {
    //     populate: 1
    //   })
    //   .then(response => {
    //     this.productos = response.data.entries,
    //       console.log(response)
    //   })

    setInterval(() => {
      this.carousel_principal++;
    }, 4000);
  },
  methods: {
    comprarAhora: function(regalo){


      this.$session.set('regalo',regalo);

      this.$router.push('/CheckoutRegalo');

      console.log(regalo);
    },
    cambiar_slide_destacada: function(e) {
      this.imagen_intro = e;
      console.log(e);
    },

    cambiar_producto_seleccionado: function(c) {
      this.producto_activo = c;
    },

    cambiar_slide: function(z) {
      this.producto_activo = z;
      if (z > this.$refs.indicadorcarousel.internalIndex) {
        var i = z - this.$refs.indicadorcarousel.internalIndex;

        for (var n = 0; n < i; n++) {
          this.$refs.indicadorcarousel.prev();
        }
      } else if (z < this.$refs.indicadorcarousel.internalIndex) {
        var i = this.$refs.indicadorcarousel.internalIndex - z;

        for (var n = 0; n < i; n++) {
          this.$refs.indicadorcarousel.next();
        }
      }
    },
    mostrarProducto: function(producto) {
      //función para mostrar nombre del producto de slide-group
      this.imagen_slider = producto;
      // console.log(producto);
    },
    agregarWishlist: function(id) {
      if (this.$session.has("user") && this.$session.get("user") != undefined) {
        var aux = this.wishlist.findIndex(element => element.id == id);

        var m = [];

        for (let n = 0; n < this.wishlist.length; n++) {
          m.push({ id: this.wishlist[n].id });
        }

        m.push({ id: id });

        console.log(aux);

        if (aux == -1) {
          axios
            .put(
              "https://strapi.actstudio.xyz/users/" +
                this.$session.get("user").user.id,
              {
                headers: {
                  Authorization: `Bearer ${this.$session.get("user").jwt}`
                },
                id: this.$session.get("user").jwt,
                productos: m
              }
            )
            .then(response => {
              this.wishlist = response.data.productos;
              console.log(response.data);
            });

          var aux2 = this;
          this.alertaWishlist = true;
          setTimeout(function() {
            aux2.alertaWishlist = false;
          }, 3000);
        } else {
          var aux2 = this;
          this.alertaWishlist = true;
          setTimeout(function() {
            aux2.alertaWishlist = false;
          }, 3000);
        }
      } else {
        var aux2 = this;
        this.alertaNoSesion = true;
        setTimeout(function() {
          aux2.alertaNoSesion = false;
        }, 3000);
      }
    },
  },
  watch: {
    $route(to, from) {
      // react to route changes...
    },
    estilo_activo: function(){
      this.prod_activo_lifestyle = 0;
    }
  },
  mounted: function(){
     //emitir evento para ocultarc menú
    this.$emit("updateMenu", 0);
    gtag('config', 'UA-163902944-1', {
      'page_title' : 'Home',
      'page_path': '/'
    });
  }
};
</script>